import moment from 'moment';

import style from '../assets/meetingStyle';
import sanitize from '../utils/sanitize';
import genContactCardTemplate from './contactCard';
import { generateFooterTemplate, generateHeaderTemplate } from './headerFooter';

const host = process.env.API_ROOT;

const processBody = details => {
  return details
    .replace(/<br><br>/g, "<div class='lineBreak'></div>")
    .replace(/<i>\s<\/i>/g, '')
    .replace(/>\s</g, '><')
    .replace(/<p [^>]*>(?:(?:<br>)|\s)<\/p>/g, '')
    .replace(/^\[|\]$/gm, '');
};

function getMeetingDates(start, end) {
  const eventStart = moment(start);
  const eventEnd = moment(end);
  const amountOfDaysBetween = eventEnd.diff(eventStart, 'days');
  const isSingleDayEvent = amountOfDaysBetween === 0;
  if (isSingleDayEvent) {
    return `${eventStart.format('LL')} from ${eventStart.format('LT')} to ${eventEnd.format('LT')}`;
  }
  return `${eventStart.format('LLL')} to ${eventEnd.format('LLL')}`;
}

const HTML_TEMPLATES = {
  bendData: ({
    data: {
      Title,
      Body,
      Attachments,
      MeetingTypeId,
      MeetingVenueEntered,
      MeetingAttend,
      MeetingType,
      MeetingVenue,
      MeetingFees,
      MeetingDateDisplay,
      DateMeetingStart,
      DateMeetingEnd,
      MeetingRegistrationUrl,
      AdditionalInfoUrl,
    },
    contacts,
    contactPics,
  }) => {
    const location = (() => {
      const entered = (MeetingVenueEntered || '').trim();
      if (MeetingTypeId !== 4) return entered || MeetingVenue;
      return entered || 'Webinar';
    })();

    return `
      <div>
        <header class="apcia-daneel-header">
          <div class="apcia-xcdwfm-container-lg-Container">
            <h2 class="apcia-pqxe18-1-normal-jumbo-Heading-title-title-Hero"><span class="apcia-16bpber-container"><span
                  class="apcia-17h9emo-text">${Title}</span></span></h2>

            ${
              MeetingType !== 'Meeting Minutes'
                ? `
                  <div style="margin-bottom: 16px;">
                    <h3 class="apcia-1ef2ux-5-bold-primaryGray-Heading-CMSPage">Meeting Dates</h3>
                    <p>${MeetingDateDisplay ||
                      getMeetingDates(DateMeetingStart, DateMeetingEnd)}</p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <h3 class="apcia-1ef2ux-5-bold-primaryGray-Heading-CMSPage">Location</h3>
                    <p>${location}</p>
                  </div>

                  <div style="margin-bottom: 16px;">
                    <h3 class="apcia-1ef2ux-5-bold-primaryGray-Heading-CMSPage">Meeting Fees</h3>
                    <p>${MeetingFees || 'None'}</p>
                  </div>
                `
                : ''
            }

          </div>
        </header>
        <div class="apcia-xcdwfm-container-lg-Container">
          <main class="apcia-ki0zl6-2-bold-2-bold-link-body">

            <article class="apcia-8w7a9g-legacyBody">
              ${
                MeetingAttend
                  ? `
                <h3 class="apcia-t4s5t4-3-bolder-primaryGray-Heading-css-Subsection">Who Should Attend</h3>
                <div class="sanitized ">
                  ${sanitize(processBody(MeetingAttend))}
                </div>
              `
                  : ''
              }

              <h3 class="apcia-t4s5t4-3-bolder-primaryGray-Heading-css-Subsection">Additional Information</h3>
              <div class="sanitized ">
                ${sanitize(processBody(Body))}
              </div>

              ${
                MeetingRegistrationUrl && MeetingRegistrationUrl.trim()
                  ? `
                  <h3 class="apcia-t4s5t4-3-bolder-primaryGray-Heading-css-Subsection">Registration</h3>
                  <p>
                    This online form is a fast and easy way to register. Be sure to
                    <a href="${MeetingRegistrationUrl}" id="ga-register-text" anchor target="_blank">
                      register today
                    </a>
                    . Once you have completed the online registration, you will receive a confirmation notice within 24 hours.
                  </p>
              `
                  : ''
              }

              ${
                Array.isArray(Attachments) && Attachments.length > 0
                  ? `
                  <h3 id="relatedinformation" class="apcia-t4s5t4-3-bolder-primaryGray-Heading-css-Subsection">
                    Related Information
                  </h3>
                  <div class="apcia-3j1ie7-Subsection">
                    <div class="ant-table-wrapper apcia-1cvdee7-table-attachmentContainer">
                      <div class="ant-spin-nested-loading">
                        <div class="ant-spin-container">
                          <div
                            class="ant-table ant-table-default ant-table-without-column-header ant-table-scroll-position-left">
                            <div class="ant-table-content">
                              <div class="ant-table-body">
                                <table class="">
                                  <colgroup>
                                    <col>
                                  </colgroup>
                                  <tbody class="ant-table-tbody">
                                    ${Attachments.map(
                                      attach => `
                                      <tr class="ant-table-row ant-table-row-level-0" data-row-key="${
                                        attach.AttachmentId
                                      }">
                                        <td class="">
                                          <a
                                            href="${attach.href}"
                                            title="${attach.FileName}" download="${
                                        attach.FileName
                                      }" class="apcia-1d6vemk-link"><i
                                              aria-label="icon: file-unknown"
                                              class="anticon anticon-file-unknown apcia-1gtgrwu-icon"><svg viewBox="64 64 896 896"
                                                focusable="false" class="" data-icon="file-unknown" width="1em" height="1em"
                                                fill="currentColor" aria-hidden="true">
                                                <path
                                                  d="M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z">
                                                </path>
                                              </svg></i><span>${attach.FileName}</span>
                                          </a>
                                        </td>
                                      </tr>
                                    `
                                    ).join('')}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                `
                  : ''
              }
            </article>
            <div class="apcia-1i569ea-legalContainer">
              <a href="${host}/legal/copyright"
                class="apcia-loigxv-link-css-CustomLink">Copyright Notice</a>
              <span
                class="apcia-1reh1on-legalSeparator">&nbsp;|&nbsp;</span>
              <a href="${host}/legal/disclaimer"
                class="apcia-loigxv-link-css-CustomLink">Legal Disclaimer</a>
            </div>

            ${
              contacts.length > 0
                ? `
              <div class="apcia-kna8zu-body">
                <div class="apcia-rmoh9-container">
                  <section class="apcia-1x4521s-lhs">
                    <div class="apcia-4vk7mv-container">
                      <div class="ant-card apcia-vkrnqj-cardSmall">
                        <div class="ant-card-head">
                          <div class="ant-card-head-wrapper">
                            <div class="ant-card-head-title">
                              <h3 class="apcia-1joqbhy-title">Contact${
                                contacts.length > 1 ? 's' : ''
                              }</h3>
                            </div>
                          </div>
                        </div>
                        <div class="ant-card-body">
                          <div class="apcia-1inls1k-inner-ContactCard">
                            ${genContactCardTemplate(contacts, contactPics)}
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            `
                : ''
            }

          </main>
        </div>
      </div>
    `;
  },
};

export function generateHTMLString(data) {
  return `
    ${generateHeaderTemplate(style)}
    ${HTML_TEMPLATES.bendData(data)}
    ${generateFooterTemplate()}
  `;
}
